import { ErrorHandler, Injectable, inject } from "@angular/core";
import { MonitoringService } from "./monitoring.service";
import { ObservabilityService } from "./observability.service";

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
    private monitoringService = inject(MonitoringService);
    private observabilityService = inject(ObservabilityService);


    public handleError(error: Error) {
        this.monitoringService.logException(error);
        this.observabilityService.logError(error);

        super.handleError(error);
    }
}
